const Text = ({ label, className, labelClassName }) => (
  <div className={className}>
    <p className={labelClassName}>{label}</p>
  </div>
);

export default Text;
